import React from 'react'
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles'
import { Card, CardContent, Box, Grid } from '@material-ui/core'
import Skeleton from '@material-ui/lab/Skeleton'
import { getRandomArbitrary } from '../../utils/Helpers'

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      position: 'relative',
      minWidth: 180,
      height: '100%'
    },
    container: {
      display: 'flex',
      justifyContent: 'space-between',
      padding: theme.spacing(4)
    },
    title: {
      fontSize: '12pt',
      fontFamily: 'Roboto, Helvetica, Arial, sans-serif',
      color: '#4B4B4B',
      fontWeight: 400
    }
  })
)

export default function ChartColumnSkeleton (): JSX.Element {
  const classes = useStyles()

  const generatelist = (): JSX.Element[] => {
    const elements: JSX.Element[] = []

    for (let index = 0; index < 12; index++) {
      elements.push(
        <Box width={80} height={`${getRandomArbitrary(40, 280)}px`} key={`chart-skeleton-item-${Math.random() * 100}`}>
          <Skeleton width="100%" height="100%">
            <div />
          </Skeleton>
        </Box>
      )
    }

    return elements
  }

  return (
    <Card className={classes.root}>
      <Grid container className={classes.container}>
        <CardContent>
          <Box width="100%">
            <Skeleton height={32} width="70%" />
          </Box>
          <Box display="flex" width="100%" justifyContent="space-between" alignItems="flex-end">
            {generatelist()}
          </Box>
        </CardContent>
      </Grid>
    </Card>
  )
}
